import { AlertTriangle, Clock, Wrench } from 'lucide-react';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { buttonVariants } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { useTranslation } from '@/hooks/useTranslation';
import { cn } from '@/lib/utils';
import { useMemo } from 'react';
import { getAppData } from '@/utils/get-app-type';

export function MaintenanceScreen() {
  const { t } = useTranslation('common');
  const appData = useMemo(() => getAppData(), []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-background to-muted flex items-center justify-center p-4">
      <div className="max-w-3xl w-full space-y-8">
        {/* Main Alert */}
        <Alert variant="destructive" className="border-destructive/50 bg-destructive/10">
          <AlertTriangle className="h-5 w-5" />
          <AlertTitle>{t('maintenance.alert.title')}</AlertTitle>
          <AlertDescription>{t('maintenance.alert.description')}</AlertDescription>
        </Alert>

        {/* Main Content Card */}
        <Card className="border-2">
          <CardHeader className="text-center">
            <div className="mx-auto mb-4">
              <img src="/undraw_maintenance.svg" className="w-64 h-64 mx-auto"
                alt='maintenance'
              />
            </div>
            <CardTitle className="text-3xl font-bold">{t('maintenance.title')}</CardTitle>
            <CardDescription className="text-lg">{t('maintenance.description')}</CardDescription>
          </CardHeader>
          <CardContent>
            <div className="space-y-6">
              {/* Time Information */}
              <div className="flex items-center justify-center space-x-2 text-muted-foreground">
                <Clock className="h-5 w-5" />
                <span>{t('maintenance.estimatedTime')}: {t('maintenance.hour', { hour: 1 })}</span>
              </div>

              {/* Maintenance Details */}
              <div className="space-y-4">
                <div className="bg-muted rounded-lg p-4">
                  <h3 className="font-semibold flex items-center gap-2 mb-2">
                    <Wrench className="h-5 w-5" />
                    {t('maintenance.whatsHappening')}
                  </h3>
                  <ul className="list-disc list-inside space-y-2 text-muted-foreground">
                    <li>{t('maintenance.item1')}</li>
                    <li>{t('maintenance.item2')}</li>
                    <li>{t('maintenance.item3')}</li>
                  </ul>
                </div>
              </div>

              {/* Status Updates */}
              <div className="text-center space-y-4">
                {/* <a
                  className={cn("w-full sm:w-auto", buttonVariants({ variant: "outline" }))}
                  href={`https://status.${appData.host}`}
                  target='_blank'
                >
                  {t('maintenance.checkStatusPage')}
                </a> */}
                <p className="text-sm text-muted-foreground">
                  {t('maintenance.supportMail')} {" "} <a className='underline'
                    href={`mailto:support@${appData.host}`}
                  >{`support@${appData.host}`}</a>
                </p>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}

export const Component = MaintenanceScreen;
